// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1NtyC","legacyBtn":"MutateMid_legacyBtn__3hpdD"};